
import {Component, Vue, Prop} from "vue-property-decorator";
import {Getter} from "vuex-class";
import QrCodeScannerWrapper from "@/components/qrcode/QrCodeScannerWrapper.vue";
import { CONTEXT_TYPES } from "@/store/modules/context";

@Component({
  components: { QrCodeScannerWrapper },
})
export default class ReserveLocation extends Vue {

    @Prop({default: null})
    public currentKey: any;

    @Prop({default: null})
    public reservedLocation: any;

    @Getter private isMobile: boolean;
    @Getter private currentUser: any;

    private display: boolean = true;
    private loadingQrCodeStreamer: boolean = false;
    private loadingSave: boolean = false;
    private scannedLocation: any = null;

    get mode(): string {
      return this.reservedLocation ? "edit" : "add";
    }

    get currentUserHasKey(): boolean {
      return this.currentKey?.KeyHolding?.find((kH) => !kH.endDate)?.userId === this.currentUser?.id;
    }

    private getLocation(decodedString: string): Promise<any> {
      if (!decodedString) { return; }
      this.loadingQrCodeStreamer = true;
      return this.$store.dispatch("context/getByToken", {
        token: decodedString,
      }).then((res: any) => {
        // If a location was scanned, display result
        if (res?.type === CONTEXT_TYPES.LOCATION) {
          this.scannedLocation = {
            id: res.id,
            name: res.name,
            keyId: res.keyId,
          };
        } else {
          // If the result isn't a location, display error
          this.$store.commit("alerts/displayError", {
            msg: this.$t(`notALocation`),
          });
        }
      }).catch((error) => {
        this.$store.commit("alerts/displayHttpError", { error });
      }).finally(() => {
        this.loadingQrCodeStreamer = false;
      });
    }

    private saveReservedLocation(): Promise<any> {
        this.loadingSave = true;
        return this.$store.dispatch("keys/reserveLocation", {
            keyId: this.currentKey.id,
            locationId: this.scannedLocation?.id || null,
        }).then(() => {
            const action = this.reservedLocation && this.scannedLocation
              ? "replaced"
              : this.scannedLocation ? "added" : "deleted";
            this.$store.commit("alerts/displaySuccess", {
                msg: this.$i18n?.t(`key.reserveLocation.${action}`, {
                  newLocation: this.scannedLocation?.name,
                  oldLocation: this.reservedLocation?.codeName,
                }),
            });
            this.$emit("saved");
            this.close();
        }).catch((error) => {
          this.$store.commit("alerts/displayHttpError", { error });
        }).finally(() => {
          this.loadingSave = false;
        });
    }

    private close(): void {
        this.$emit("close");
        this.scannedLocation = null;
    }
}
